import { TransactionStatus } from '@api/ecommerce-xp';
import { imagesBcp } from '@assets';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { ImageProps } from '@bcp-nextgen-dx-component-factory/design-system';
import { getSavedTokenDataFromStorage, rem } from '@helpers';
import { useNavigation } from '@navigation';
import { useServiceError, useServiceResponse } from '@store';

interface ServiceErrorResources {
	message: string;
	button: string;
}

interface ServiceErrorOutput {
	imageProps: ImageProps;
	resources: ServiceErrorResources;
	onClickHandler: () => void;
}

export const useServiceErrorHelper = (): ServiceErrorOutput => {
	const { subscription } = useServiceResponse();
	const { gotoHome, exit } = useNavigation();
	const t = useTranslation();
	const serviceError = useServiceError();
	const returnUrl = getSavedTokenDataFromStorage<string>('returnUrl');

	let resources = {
		message: serviceError?.message || '',
		button: t('general.back'),
	};
	let imageProps: ImageProps = {
		source: imagesBcp.warningIcon,
		svgProps: {
			width: rem(77.94),
			height: rem(77.94),
		},
	};
	if (
		subscription &&
		(subscription.transactionStatus === TransactionStatus.TOSTOREANDFOWARDFORM ||
			subscription.transactionStatus === TransactionStatus.PROCESSING)
	) {
		resources = {
			message: t('serviceError.inProcessing'),
			button: t('general.back'),
		};
		imageProps = {
			source: imagesBcp.roundIconInProcessing,
			svgProps: {
				width: rem(77.94),
				height: rem(77.94),
			},
		};
	}

	const onClickHandler = () => {
		if (returnUrl) {
			exit();
		} else {
			gotoHome();
		}
	};

	return {
		imageProps,
		resources,
		onClickHandler,
	};
};
